import React, { FC } from 'react'
import DatePicker from "react-datepicker";

import { DateTimeUtils } from '../../../modules/utils';

// ============================ Date Time ============================
type IDateTimeProps = {
    onChange: (time: number) => void,
    maxDetail?: string,
    isSecondTime?: boolean,
    locale?: string,
    value?: any,
    minDate?: number,
    maxDate?: number,
    className?: string,
    disabled?: boolean,
    onBlur?: ((event?: React.FocusEvent<HTMLInputElement>) => void) | undefined,
    onFocus?: ((event?: React.FocusEvent<HTMLInputElement>) => void) | undefined,
    defaultValue?: number,
}

export const InputDatePicker: FC<IDateTimeProps> = (props) => {
    const { onChange, minDate, maxDate, isSecondTime, disabled, className } = props;

    const handleChange = (date: any) => {
        let time: any;

        if (date) {
            time = new Date(date).getTime();
            if (isSecondTime) time = DateTimeUtils.timeToSeconds(date);
        }

        if (onChange) return onChange(time);
    }

    const convertTime = (time: any) => {
        if (!time) return;
        if (isSecondTime) return DateTimeUtils.secondsToTime(time);
        return new Date(time);
    }

    return <DatePicker
        className={`InputDatePicker ${className}`}
        selected={props.value ? new Date(props.value) : undefined}
        value={props.value}
        onChange={date => handleChange(date)}
        minDate={convertTime(minDate)}
        maxDate={convertTime(maxDate)}
        disabled={disabled}
        onCalendarClose={() => props.onFocus && props.onFocus()}
        onCalendarOpen={() => props.onBlur && props.onBlur()}
        onBlur={() => props.onBlur && props.onBlur()}
        onFocus={() => props.onFocus && props.onFocus()}
        dateFormat="dd/MM/yyyy"
    />
}

InputDatePicker.defaultProps = {
    isSecondTime: false,
    locale: 'en-GB',
}